var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var videosSubscription;
var Paginator = /** @class */ (function () {
    function Paginator(sanity) {
        var _this = this;
        this.paging = {
            maxPages: 1,
            totalNumberOfVideos: 0,
            currentPage: 1,
            videosPerPage: 25
        };
        this.startIndex = 0;
        this.endIndex = 25;
        this.videos = {};
        this.getTotalNumberOfVideos = function () { return __awaiter(_this, void 0, void 0, function () {
            var query, initialNumber;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = "count(" + this.sanity.query + ")";
                        return [4 /*yield*/, this.sanity.client.fetch(query)];
                    case 1:
                        initialNumber = _a.sent();
                        this.paging.totalNumberOfVideos = initialNumber;
                        this.updatePagingState();
                        return [2 /*return*/];
                }
            });
        }); };
        this.getVideos = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, query, params, initialData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.queryAndParams, query = _a.query, params = _a.params;
                        return [4 /*yield*/, this.sanity.client.fetch(query, params)];
                    case 1:
                        initialData = _b.sent();
                        return [4 /*yield*/, this.getTotalNumberOfVideos()];
                    case 2:
                        _b.sent();
                        this.callCalbackAllVideosFn(initialData);
                        this.updatePagingState();
                        this.videos = this.getVideoAssetMap(initialData);
                        this.registerPaginatorSubscription();
                        return [2 /*return*/];
                }
            });
        }); };
        this.registerPaginatorSubscription = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, query, params;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.queryAndParams, query = _a.query, params = _a.params;
                if (videosSubscription)
                    videosSubscription.unsubscribe();
                videosSubscription = this.sanity.client.listen(query, params).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: 
                            // When the logic for updating videos on the go is implemented, we can uncomment these again
                            // this.getTotalNumberOfVideos()
                            // this.updateVideos(data)
                            return [4 /*yield*/, this.getVideos()];
                            case 1:
                                // When the logic for updating videos on the go is implemented, we can uncomment these again
                                // this.getTotalNumberOfVideos()
                                // this.updateVideos(data)
                                _a.sent();
                                this.updatePagingState();
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        this.getVideoAssetMap = function (videos) {
            var res = {};
            for (var _i = 0, videos_1 = videos; _i < videos_1.length; _i++) {
                var video = videos_1[_i];
                res[video.resource_key] = video;
            }
            return res;
        };
        this.updatePagingState = function () {
            var newPaging = __assign({}, _this.paging);
            newPaging.maxPages = Math.floor(_this.paging.totalNumberOfVideos / _this.paging.videosPerPage) + 1;
            delete newPaging.next;
            if (_this.paging.currentPage < _this.paging.maxPages) {
                newPaging.next = _this.getNext;
            }
            delete newPaging.previous;
            if (_this.paging.currentPage > 1) {
                newPaging.previous = _this.getPrevious;
            }
            _this.paging = newPaging;
            _this.callCalbackStateFn(newPaging);
        };
        this.getNext = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.paging.next) {
                    return [2 /*return*/, console.error('Could not find any next paging call.')];
                }
                this.paging.currentPage++;
                this.startIndex = this.startIndex + this.paging.videosPerPage;
                this.endIndex = this.endIndex + this.paging.videosPerPage;
                this.callCalbackStateFn(this.paging);
                this.getVideos();
                return [2 /*return*/];
            });
        }); };
        this.getPrevious = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.paging.previous) {
                    return [2 /*return*/, console.error('Could not find any previous paging call.')];
                }
                this.paging.currentPage--;
                this.startIndex = this.startIndex - this.paging.videosPerPage;
                this.endIndex = this.endIndex - this.paging.videosPerPage;
                this.callCalbackStateFn(this.paging);
                this.getVideos();
                return [2 /*return*/];
            });
        }); };
        this.sanity = sanity;
    }
    Object.defineProperty(Paginator.prototype, "queryAndParams", {
        get: function () {
            var query = this.sanity.query + " | order(_createdAt desc) [$start ... $stop]";
            var params = { start: this.startIndex, stop: this.endIndex };
            return { query: query, params: params };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Paginator.prototype, "videoArray", {
        get: function () {
            return Object.values(this.videos).sort(function (videoA, videoB) {
                return videoB.created_unix_time - videoA.created_unix_time;
            }).slice(0, this.paging.videosPerPage);
        },
        enumerable: false,
        configurable: true
    });
    // private fetchNewVideo = ()
    Paginator.prototype.updateVideos = function (event) {
        var tmpVideos = __assign({}, this.videos);
        // TODO: Implement logic for fetching new videos when we delete one here
        if (event.transition === 'disappear') {
            delete tmpVideos[event.documentId];
        }
        else if (event.result) {
            tmpVideos[event.documentId] = event.result;
        }
        this.videos = tmpVideos;
        this.callCalbackAllVideosFn(this.videoArray);
    };
    Paginator.prototype.setCallbackFn = function (callbackStateFn, callbackAllVideosFn) {
        this.callbackStateFn = callbackStateFn;
        this.callbackAllVideosFn = callbackAllVideosFn;
    };
    Paginator.prototype.callCalbackStateFn = function (state) {
        if (!this.callbackStateFn)
            return console.error('No callback function for state provided. This is necessary to keep the application reactive.');
        this.callbackStateFn(state);
    };
    Paginator.prototype.callCalbackAllVideosFn = function (videos) {
        if (!this.callbackAllVideosFn)
            return console.error('No callback function for videos provided. This is necessary to keep the application reactive.');
        this.callbackAllVideosFn(videos);
    };
    return Paginator;
}());
export { Paginator };
